import React, { Component } from 'react';

export class Blog extends Component {
    static displayName = Blog.name;

    constructor(props) {
        super(props);
        this.state = {};
       
    }

   

    render() {
        return (
            <div>
                <h1>Blog</h1>

                <p>This will eventually be a blog</p>
            </div>
        );
    }
}
